import ProviderInvoiceFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ProviderInvoiceFormData, ProviderInvoiceRelatedAttributes } from "@/formTypes/ProviderInvoiceDataType";
import { ProviderInvoiceApi, ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { getDefaultCurrency } from "@utils/Currency";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import LoadXmlDataForm from "@components/dynamic/LoadXmlDataForm";
import { loadXmlDocument } from "@utils/EDocument";
import LoadingScreen from "@components/content/LoadingScreen";
import { ProviderInvoiceCategoryApi } from "@/api/ProviderInvoiceCategoryApi";
import { omitProperties } from "@utils/Utils";
import { PROVIDER_CASH_INVOICE_TYPE, PROVIDER_INVOICE_CASH_TYPES } from "@utils/Constants";
import { showAlert } from "@utils/Alert";
import { NotFoundError } from "@/api/ApiClient";
import { e } from "mathjs";
import { loadReferenceFormLabel } from "@utils/Forms";
import { useAppSelector } from "@/store/hooks";

type ProviderInvoiceFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const ProviderInvoiceForm = (props: ProviderInvoiceFormProps) => {
  const [defaultData, setDefaultData] = useState<ProviderInvoiceDataType>({});
  const formRef = useRef<DynamicFormRef>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);
  const [formConfig, setFormConfig] = useState<any>();

  useEffect(() => {
    loadFormConfig()
  }, [suscriptionData])

  useLayoutEffect(() => {
    const run = async () => {
      const defaultCurrency = await getDefaultCurrency()
      if (defaultCurrency.id) {
        setDefaultData({ currencyId: defaultCurrency.id })
        CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id, forceUpload: false })
      }
    }
    run();
  }, []);

  const onInputChange = async (name: keyof ProviderInvoiceDataType, value: any) => {
    // if (name == "clientId") {
    //   const clientData = await ClientApi.get(value);
    //   formRef.current?.setFormValue("nombre", `${clientData.nombre}`, "String");
    // }
  }

  const onXMLFileLoad = async (fileData: unknown) => {
    setIsLoading(true)
    try {
      const { documentData } = await loadXmlDocument(fileData, ["FacturaElectronica"])
      const defaultCategoria = await ProviderInvoiceCategoryApi.find({ is_default: { eq: true } });
      const providerInvoiceData = omitProperties(documentData || {}, ["Products", "identificacion"])

      const alreadyAdded = await documentExist(`${documentData?.document_key}`)
      if (alreadyAdded) {
        showAlert("warning", "Esta factura ya se encuentra registrada en el sistema")
      }

      const defaultData: Partial<ProviderInvoiceFormData> = {
        ...providerInvoiceData,
        providerInvoiceCategoryId: defaultCategoria?.id || ""
      }
      formRef.current?.resetFormValue(defaultData);
    } catch (err) {
      if (err instanceof Error) {
        showAlert("danger", err.message)
      }
    }
    finally {
      setIsLoading(false)
    }
  }

  const documentExist = async (documentKey: string) => {
    try {
      await ProviderInvoiceApi.getInvoiceByDocumentKey(documentKey);
    } catch (err) {
      if (err instanceof NotFoundError) {
        return false
      } else {
        throw err
      }
    }
    return true
  }

  const createInvoice = async (input: ProviderInvoiceDataType): Promise<ProviderInvoiceDataType> => {
    let invoiceData = {
      ...input,
      status: "pendiente"
    }
    if (`${input.tipo}` == `${PROVIDER_INVOICE_CASH_TYPES}`) {
      invoiceData.status = "pagada"
    }

    return await ProviderInvoiceApi.create(invoiceData)
  }

  const updateInvoice = async (id: string, input: ProviderInvoiceDataType): Promise<ProviderInvoiceDataType> => {
    let invoiceData = { ...input }
    if (`${input.tipo}` == `${PROVIDER_INVOICE_CASH_TYPES}`) {
      invoiceData.status = "pagada"
    } else {
      if (invoiceData.providerRecibeId) {
        invoiceData.status = "pagada"
      } else {
        invoiceData.status = "pendiente"
      }
    }
    return await ProviderInvoiceApi.update(id, invoiceData)
  }

  const loadFormConfig = () => {
    const formConfig = loadReferenceFormLabel(ProviderInvoiceFormConfig, suscriptionData);
    if (suscriptionData?.id) {
      setFormConfig(formConfig)
    }
  }

  return (
    <>
      {formConfig?.sections && (<>
        <LoadXmlDataForm
          onFileLoaded={onXMLFileLoad}
        />
        <GenericForm<ProviderInvoiceFormData, ProviderInvoiceDataType>
          id={props.id}
          ref={formRef}
          formId={props.formId}
          defaultData={defaultData}
          saveRedirectUrl={props.saveRedirectUrl}
          onInputChange={onInputChange}
          modelRelativeObjects={ProviderInvoiceRelatedAttributes}
          formConfig={formConfig}
          getById={(...arg) => ProviderInvoiceApi.get(...arg)}
          createFn={(...arg) => createInvoice(...arg)}
          updateFn={(...arg) => updateInvoice(...arg)}
          successMessage="La Factura del Provedor ha sido almacenada correctamente"
          errorMessage="No fue posible almacenar la información de la Factura del provedor"
        />
        <LoadingScreen isLoading={isLoading} />
      </>)}
    </>
  )
}

export default ProviderInvoiceForm;